import React, { TextareaHTMLAttributes } from "react";
import styles from "./Textarea.module.scss";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  placeholder?: string;
  error?: string;
  maxLength?: number;
  showCount?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
  label,
  placeholder,
  error,
  className = "",
  maxLength = 500,
  showCount = true,
  value = "",
  ...rest
}) => {
  const currentLength = String(value).length;

  return (
    <div className={`${styles.textareaWrapper} ${className}`}>
      {label && (
        <div className={styles.labelContainer}>
          <label className={styles.label}>{label}</label>
          {showCount && maxLength !== undefined && (
            <span className={styles.counter}>
              {currentLength}/{maxLength}
            </span>
          )}
        </div>
      )}

      <textarea
        className={`${styles.textarea} ${error ? styles.textareaError : ""}`}
        placeholder={placeholder}
        maxLength={maxLength}
        value={value}
        {...rest}
      />

      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default Textarea;
